import { Form, Input, Cascader, Select, Radio, Row, Col } from 'antd';
import SelectOrganization from '../department-tree';
import Uploader from '../uploader';
import UploadFile from '../upload-file';
import SkuTree from '../sku-tree';
import { getRules, Data, getCodeToId, restrictCNLength } from '../../utils';
import { vaildTag, validateErp } from '../../apis';
import link from '@/constants/friend-links';

import './index.less';

const { Option } = Select;

const options = [
  {
    label: '功能互动类',
    value: '01',
    children: [
      {
        label: '基础功能类',
        value: '1',
      },
      {
        label: '服务类',
        value: '2',
      },
      {
        label: '互动游戏类',
        value: '3',
      },
    ],
  },
  {
    label: '营销频道类',
    value: '02',
    children: [
      {
        label: '促销类',
        value: '4',
      },
      {
        label: '垂直品类导购类',
        value: '5',
      },
      {
        label: '特定身份营销类',
        value: '6',
      },
      {
        label: '内容营销类',
        value: '7',
      },
    ],
  },
];

const { Item } = Form;
interface Props {
  data: Data;
  items: Data[];
}

const renderNormalItem = (data: Data): boolean | JSX.Element => {
  const { id, dataType, name, itemOptionVOList /*code*/ } = data;
  if (dataType === 18) {
    return (
      <Item
        name={id}
        label={name}
        rules={[
          {
            required: JSON.parse(getRules('required', data)),
            message: `请选择${name}`,
          },
        ]}
      >
        <Select placeholder={`请选择${name}`} style={{ width: 345 }}>
          {itemOptionVOList.map((item) => (
            <Option value={item.optionValue} key={item.optionValue}>
              {item.optionText}
            </Option>
          ))}
        </Select>
      </Item>
    );
  }
  if (dataType === 2) {
    return (
      <Item
        name={id}
        label={name}
        className="form-uploader"
        rules={[
          {
            required: JSON.parse(getRules('required', data)),
            message: `请上传${name}`,
          },
        ]}
      >
        <Uploader data={data} />
      </Item>
    );
  }
  if (dataType === 1) {
    return (
      <Item
        name={id}
        label={name}
        rules={[
          {
            required: JSON.parse(getRules('required', data)),
          },
          // {
          //   max: +getRules('maxLength', data),
          // },
          // {
          //   min: +getRules('minLength', data),
          // },
          {
            validator: (v, val) => {
              return restrictCNLength(+getRules('maxLength', data), val);
            },
          },
        ]}
      >
        <Input placeholder={`请输入${getRules('maxLength', data)}字符以内的${name}`} style={{ width: 345 }} />
      </Item>
    );
  }
  return false;
};

const getDynamicItem = (props: Props): JSX.Element => {
  const { code, name, id } = props.data;
  const { data, items } = props;

  const crowdTypeId = getCodeToId('crowdType', items);
  const crowdId = getCodeToId('crowd', items);

  const dynamicItem: any = {
    name() {
      return (
        <Item
          name={id}
          label={name}
          rules={[
            {
              required: JSON.parse(getRules('required', data)),
            },
            {
              validator: (v, val) => {
                return restrictCNLength(+getRules('maxLength', data), val);
              },
            },
          ]}
        >
          <Input style={{ width: 345 }} placeholder={`请输入${getRules('maxLength', data)}字符以内的频道名称`} />
        </Item>
      );
    },
    desc() {
      return (
        <Item
          name={id}
          label={name}
          rules={[
            {
              required: JSON.parse(getRules('required', data)),
            },
            {
              validator: (v, val) => {
                return restrictCNLength(+getRules('maxLength', data), val);
              },
            },
          ]}
        >
          <Input.TextArea
            style={{ width: 500 }}
            placeholder={`请输入${getRules('maxLength', data)}字符以内的详细频道描述信息`}
          />
        </Item>
      );
    },
    faceErp() {
      return (
        <Item
          name={id}
          label={name}
          validateFirst
          validateTrigger="onBlur"
          rules={[
            {
              required: JSON.parse(getRules('required', data)),
            },
            {
              validator: async (v, val) => {
                const res = await validateErp({ erps: val });
                if (res.ret === '0') {
                  return Promise.resolve();
                } else {
                  return Promise.reject(new Error(res.msg));
                }
              },
            },
          ]}
        >
          <Input style={{ width: 345 }} placeholder="请输入对接人erp" />
        </Item>
      );
    },
    departmentName() {
      return (
        <Item
          name={id}
          label={name}
          rules={[
            {
              required: JSON.parse(getRules('required', data)),
            },
            {
              max: +getRules('maxLength', data),
            },
          ]}
        >
          <SelectOrganization width={345} />
        </Item>
      );
    },
    channelType() {
      return (
        <Item
          name={id}
          label={name}
          rules={[
            {
              required: JSON.parse(getRules('required', data)),
            },
          ]}
        >
          <Cascader options={options} placeholder="请选择频道类型" style={{ width: 345 }} />
        </Item>
      );
    },
    cateInfo() {
      return (
        <Item
          name={id}
          label={name}
          rules={[
            {
              required: JSON.parse(getRules('required', data)),
            },
          ]}
        >
          <SkuTree width={345} placeholder="请选择和搜索品类" />
        </Item>
      );
    },
    jumpUrl() {
      return (
        <Item className="form-dync-url" wrapperCol={{ span: 24 }}>
          <Item
            name={id}
            label={name}
            validateTrigger="onBlur"
            validateFirst
            rules={[
              {
                required: JSON.parse(getRules('required', data)),
              },
              {
                validator: (t, val) => {
                  if (new RegExp(getRules('regex', data)).test(val)) {
                    return Promise.resolve();
                  } else {
                    return Promise.reject(new Error('链接格式错误'));
                  }
                },
              },
            ]}
          >
            <Input placeholder="请输入通天塔页面链接" style={{ width: 345 }} />
          </Item>
          <a
            className="to-babel"
            target="_blank"
            rel="noopener noreferrer"
            href={`${link[2].href}`}
            // @ts-ignore
            clstag="resource_1627030927203|7"
          >
            去通天塔搭建
          </a>
        </Item>
      );
    },
    crowdType() {
      return (
        <>
          <Row>
            <Col className="bebel-title">投放策略</Col>
          </Row>
          <Item
            noStyle
            shouldUpdate={(prevValues, currentValues) => {
              return prevValues[crowdTypeId] !== currentValues[crowdTypeId];
            }}
          >
            {({ setFields }) => (
              <Item
                name={id}
                label={name}
                rules={[
                  {
                    required: true,
                  },
                  {
                    max: +getRules('maxLength', data),
                  },
                ]}
              >
                <Radio.Group
                  onChange={(e) => {
                    const filed: any = {
                      name: crowdId,
                      value: '',
                      validating: false,
                      touched: false,
                      errors: [],
                    };
                    setFields([filed]);
                  }}
                >
                  {data.itemOptionVOList.map((item) => (
                    <Radio value={item.optionValue} key={item.optionValue}>
                      {item.optionText}
                    </Radio>
                  ))}
                </Radio.Group>
              </Item>
            )}
          </Item>
        </>
      );
    },
    crowd() {
      return (
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) => {
            return prevValues[crowdTypeId] !== currentValues[crowdTypeId];
          }}
        >
          {({ getFieldValue }) => {
            return getFieldValue(crowdTypeId) === '1' ? (
              <Form.Item
                className="form-file"
                name={id}
                label="pin包"
                rules={[{ required: true, message: '请上传种子pin包' }]}
              >
                <UploadFile />
              </Form.Item>
            ) : (
              <Item className="form-dync-url" wrapperCol={{ span: 24 }}>
                <Item
                  name={id}
                  label="经海路标签ID"
                  validateFirst
                  validateTrigger="onBlur"
                  rules={[
                    { required: true },
                    {
                      validator: async (v, val) => {
                        const res = await vaildTag({ groupId: +val });
                        if (res.ret === '0' && res.data) {
                          return Promise.resolve();
                        } else {
                          return Promise.reject(new Error('标签不存在'));
                        }
                      },
                    },
                  ]}
                >
                  <Input placeholder="请输入经海路标签ID" style={{ width: 345 }} />
                </Item>
                <a
                  className="to-babel"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="http://jinghailu.jd.com/index?url=http://jinghailu.jd.com/label/label-config"
                  // @ts-ignore
                >
                  创建经海路标签
                </a>
              </Item>
            );
          }}
        </Form.Item>
      );
    },
  };
  const fuc = dynamicItem[code] ? dynamicItem[code]() : renderNormalItem(data);
  return fuc;
};

export default getDynamicItem;
